<template>
    <div class="own-custom-select-option" :disabled="disabled" @click="setSelection" :class="{'selected': isSelected || selected }">
        <input type="checkbox" class="md-primary" v-model="selected" v-if="isMultiple" :disabled="disabled" />
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'OwnSelectOption',
    props:{
        disabled:[Boolean],
        value: [String, Number, Boolean, Object],             
    },
    data(){
        return{
            selected:false
        }
    },    
    inject:['OwnSelect'],
    computed:{
        isSelected(){
            let _this = this
            if (!this.isMultiple ){
                return _this.OwnSelect.modelValue == _this.value 
            } else {         
                if (_this.OwnSelect.modelValue){
                    if (_this.OwnSelect.modelValue.find(item => item == _this.value)) {
                        _this.selected = true
                    } else {
                        _this.selected = false
                    }
                       
                }                

                return false
            }                        
        },
        isMultiple () {
            // return this.$parent.multiple
            return this.OwnSelect.multiple
        },
        getOptionText(){            
            var slot = this.$slots.default
            return slot ? slot[0].text.trim() : ''
        }
    },
    methods:{
        setSelection () {
            if (!this.disabled) {
                if (this.isMultiple) {
                    this.setMultipleSelection()
                } else {
                    this.setNormalSelection()
                }
                
            }
        },
        setNormalSelection(){
            let _this = this
            this.OwnSelect.setValue(_this.value)
        },
        setMultipleSelection(){
            let _this = this
            this.selected = !this.selected
            this.OwnSelect.setValueMultiply(_this.value)
        },        
    },
    created(){
        // console.log('custom select option create')
        

        if (this.OwnSelect.multiple){
            this.OwnSelect.setMultiplyTextAll(this.getOptionText, this.value)        
        }
        
    },    
    
}
</script>

<style lang="scss">
    .own-custom-select-option{
        padding:10px 20px;
        cursor: pointer;

        &:hover{
            background: rgba(0,0,0,0.05);
        }

        &.selected{
            font-weight: 500;
            color:#2F80ED;
            border:none;
        }
    }
</style>